import axios from "axios";
import { authConfig, endpoint } from "./http";

const AUTH_REQUEST_TIMEOUT_MS = 10000;
let activeRefreshRequest = null;

function authRequestConfig(config = {}) {
  return {
    ...config,
    timeout: AUTH_REQUEST_TIMEOUT_MS,
    withCredentials: true,
  };
}

export async function login({ apiUrl, email, password }) {
  const response = await axios.post(
    endpoint(apiUrl, "/auth/login"),
    {
      email,
      password,
    },
    authRequestConfig()
  );

  return response.data;
}

export async function refreshSession({ apiUrl }) {
  if (!activeRefreshRequest) {
    activeRefreshRequest = axios.post(
      endpoint(apiUrl, "/auth/refresh"),
      {},
      authRequestConfig({ _skipAuthRefresh: true })
    ).then((response) => response.data).finally(() => {
      activeRefreshRequest = null;
    });
  }
  return activeRefreshRequest;
}

export async function logout({ apiUrl }) {
  const response = await axios.post(
    endpoint(apiUrl, "/auth/logout"),
    {},
    authRequestConfig({ _skipAuthRefresh: true })
  );

  return response.data;
}

export async function getCurrentAuthUser({ apiUrl, accessToken }) {
  const response = await axios.get(
    endpoint(apiUrl, "/auth/me"),
    authRequestConfig(authConfig(accessToken))
  );

  return response.data;
}

export async function register({ apiUrl, displayName, email, password, role = "user" }) {
  const response = await axios.post(
    endpoint(apiUrl, "/auth/register"),
    {
      email,
      password,
      display_name: displayName,
      role,
    },
    authRequestConfig()
  );

  return response.data;
}
